import { Flex, Text, useNavItemSubmit, useScrollToElement } from '@billy/design-system'
import upperFirst from 'lodash/upperFirst'
import { ReactElement, useCallback, useRef } from 'react'
import Highlighter from 'react-highlight-words'

import { SearchResultItem } from '../../types/searchResultItem'
import * as Styled from './styles'

interface OrganizationsSearchItemProps {
  item: SearchResultItem
  onClick?: (item: SearchResultItem) => void
  searchValue?: string
  focusedId?: string
}

export const OrganizationsSearchItem = ({
  item,
  onClick,
  searchValue = '',
  focusedId,
}: OrganizationsSearchItemProps): ReactElement => {
  const { id, text, icon } = item
  const listItemRef = useRef<HTMLLIElement>(null)
  const textFormatted = upperFirst(text)

  const isFocused = focusedId === id
  const searchWords = searchValue.split(' ')

  const handleItemClick = useCallback(() => {
    onClick?.(item)
  }, [item, onClick])

  const handleKeyDown = useCallback(() => {
    if (isFocused) {
      listItemRef.current?.click()
    }
  }, [isFocused])

  useScrollToElement(listItemRef, isFocused)
  useNavItemSubmit(handleKeyDown, isFocused, [item, isFocused, handleKeyDown])

  return (
    <Styled.ListItem ref={listItemRef} onClick={handleItemClick} focused={isFocused} tabIndex={0}>
      <figure>{icon}</figure>
      <Flex alignItems="center">
        <Text title={textFormatted} weight="regular" truncate>
          <Highlighter searchWords={searchWords} textToHighlight={textFormatted} autoEscape />
        </Text>
      </Flex>
    </Styled.ListItem>
  )
}
